import { render, staticRenderFns } from "./PurchaseOrderForm.vue?vue&type=template&id=f6bc1a1a&"
import script from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports